import React from 'react'
import PropTypes from 'prop-types'

import { UploadIcon, MediaIcon } from 'images'
import { useTranslation } from 'react-i18next'
import InfoBox from 'components/Shared/InfoBox'

export const UploadButtons = ({
  hasMedia,
  onDeviceUpload,
  onLibraryUpload,
  disabled = false,
  isCampaignRunning = false,
  showLimitInfoBox = true,
  getInputProps,
}) => {
  const { t } = useTranslation()

  const canShowInfobox = disabled ? ['hover', 'focus'] : 'none'

  return (
    <InfoBox
      title={t('Tips.Recommendations.Limit.title')}
      body={t('Tips.Recommendations.Limit.media')}
      withAnchor={false}
      enabled={showLimitInfoBox}
      trigger={!isCampaignRunning && canShowInfobox}
      classNames="text-wrap"
    >
      <div onClick={(event) => disabled && event.stopPropagation()}>
        <div className={`upload-buttons mt-3 ${hasMedia ? 'has-media' : ''}`}>
          {getInputProps && (
            <input {...getInputProps()} style={{ display: 'none' }} />
          )}

          <button
            className="upload-button"
            type="button"
            disabled={disabled || !onLibraryUpload}
            onClick={onLibraryUpload}
          >
            <div className="icon">
              <MediaIcon width={18} height={18} />
            </div>

            <div className="content">
              <p className="title">{t('Recommendations.campaign.setup.media.uploadButtons.gallery.title')}</p>
              <p className="description">{t('Recommendations.campaign.setup.media.uploadButtons.gallery.description')}</p>
            </div>
          </button>

          <button
            className="upload-button"
            type="button"
            disabled={disabled}
            onClick={onDeviceUpload}
          >
            <div className="icon">
              <UploadIcon width={18} height={18} />
            </div>

            <div className="content">
              <p className="title">{t('Recommendations.campaign.setup.media.uploadButtons.device.title')}</p>
              <p className="description">{t('Recommendations.campaign.setup.media.uploadButtons.device.description')}</p>
            </div>
          </button>
        </div>
      </div>
    </InfoBox>
  )
}

UploadButtons.propTypes = {
  hasMedia: PropTypes.bool.isRequired,
  onDeviceUpload: PropTypes.func,
  onLibraryUpload: PropTypes.func,
  disabled: PropTypes.bool,
  isCampaignRunning: PropTypes.bool,
  showLimitInfoBox: PropTypes.bool,
  getInputProps: PropTypes.func,
}
